module.exports = __webpack_public_path__ + "static/media/serena-win.4f63b409.png";